import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';
const confirm = Modal.confirm;
import { graphql, compose, withApollo } from 'react-apollo';

import SelectorModelo from '../formularios/SelectorModelo';
import FormAcreditacion from '../formularios/FormAcreditacion';
import Generador from '../../generador/Generador';
import CKEditor from '../../editor/Example';
import Loading from '../../common/Loading';

import insertPersona from '../../../graphql/mutations/persona/insertPersona.graphql';
import insertAcreditacion from '../../../graphql/mutations/tramites/insertAcreditacion.graphql';
import crearAcreditacion from '../../../graphql/mutations/tramites/crearAcreditacion.graphql';
import confirmarAcreditacion from '../../../graphql/mutations/tramites/confirmarAcreditacion.graphql';
import obtenerNumeroTalonario from '../../../graphql/mutations/editor/obtenerNumeroTalonario.graphql';
import insertDetalleVenta from '../../../graphql/mutations/venta/insertDetalleVenta.graphql';
import insertVenta from '../../../graphql/mutations/venta/insertVenta.graphql';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import { imprimir } from '../../common/funciones/imprimir';

import moment from 'moment';
import _ from 'lodash';
import { errorService } from '../../../graphql/utils/utils';
import { verPdf } from '../../common/funciones/verPdf';
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertAcreditacion, {
    name: 'createAcreditacion',
  }),
  graphql(crearAcreditacion, {
    name: 'crearAcreditacion',
  }),
  graphql(insertPersona, {
    name: 'createPers',
  }),
  graphql(confirmarAcreditacion, {
    name: 'confirmarAcreditacion',
  }),
  graphql(insertDetalleVenta, {
    name: 'insertDetalleVenta',
  }),
  graphql(insertVenta, {
    name: 'insertVenta',
  }),
  graphql(getUsuario)
)
class CrearAcreditacion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      persona: {},
      numero: '',
      step: 0,
      guardado: false,
      confirmado: false,
      existeVenta: false,
      loading: false,
      detalles: [],
      datosPosnet: {},
      extras: {},
    };

    this.guardarDatosAcreditacion = this.guardarDatosAcreditacion.bind(this);
    this.notaSeleccionada = this.notaSeleccionada.bind(this);
    this.siguientePaso = this.siguientePaso.bind(this);
    this.anteriorPaso = this.anteriorPaso.bind(this);
    this.confirmarAcreditacion = this.confirmarAcreditacion.bind(this);

    this.finProcesoGeneracion = this.finProcesoGeneracion.bind(this);
    this.obtenerDatosGeneracion = this.obtenerDatosGeneracion.bind(this);
    this.onImprimir = this.onImprimir.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarPersona = persona => {
    this.setState(
      {
        persona: {
          ...this.state.persona,
          ...persona,
        },
      },
      function() {
        this.siguientePaso();
      }
    );
  };

  guardarDatosAcreditacion(datos, ventaSinStock) {
    // console.log(datos);

    this.setState(
      {
        ...this.state,
        existeVenta: datos.existeVenta,
        detalles: datos.detalles,
        datosPosnet: datos.datosPonset,
        datosMP: datos.datosMP,
        extras: datos.extras,
      },
      function() {
        this.persistirDatos(ventaSinStock);
      }
    );
  }

  notaSeleccionada(idNota) {
    this.setState({
      ...this.state,
      nota: {
        idModeloNota: idNota,
      },
    });
  }

  obtenerDatosGeneracion() {
    //Este metodo es el encargado de, dependiendo lo necesario, de generar un unico objeto que
    //Será utilizado para pasarselo al componente generador como datos de entradas.

    let textoOperacion = `Este tramite fue exento del pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    if (this.state.acreditacion && this.state.acreditacion.venta) {
      let venta = this.state.acreditacion.venta;
      textoOperacion = `Por este trámite se abono la suma de $${
        venta.importe
      } mediante el uso de ${
        venta.tipoPago
      }, en concepto de pago de tasa de justicia - Ley N° 1971 Art. 3 -`;
    }

    let datos = {
      ...this.state.persona,
      direccion_otro:
        this.state.persona.direccion_otro &&
        this.state.persona.direccion_otro.length > 0
          ? this.state.persona.direccion_otro
          : ' ',
      numero: this.state.numero,
      organismo: this.props.data.getUsuario.organismo,
      textoOperacion: textoOperacion,
    };

    // console.log("los datos quedan de la siguiente manera: ");
    // console.log(datos);

    return datos;
  }

  finProcesoGeneracion(textoGenerado) {
    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          htmlModelo: textoGenerado,
        },
      },
      function() {
        //Esta es una acreditacion de una funcion sincronica, que espera a que el setState se haga para ejecutarse. Un Callback
        this.siguientePaso();
      }
    );
  }

  async onImprimir(htmlFinal) {
    const rta = await this.confirmarAcreditacion();

    if (rta || this.state.confirmado) {
      //TODO: IMPRIMIR
      // console.log("La respuesta es.....");
      // console.log(rta);
      imprimir(htmlFinal);
    }
  }

  async confirmarAcreditacion() {
    const { confirmado, acreditacion } = this.state;

    if (!confirmado) {
      try {
        const rta = await this.props.confirmarAcreditacion({
          variables: {
            _id: acreditacion._id,
            idModeloNota: this.state.nota.idModeloNota,
            numero: this.state.numero,
          },
        });
        if (rta) {
          notification.success({
            message: 'Acreditacion  Confirmada!',
            description: 'Se ha confirmado con exito la Acreditacion ',
          });

          this.setState({
            ...this.state,
            confirmado: true,
          });

          return rta;
        }
      } catch (err) {
        console.log('excepcion al confirmar la acreditacion jurada');
        console.log(err);

        Modal.error({
          title: 'Error en la confirmacion de la acreditacion jurada',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      }
    }
  }

  persistirDatos(ventaSinStock) {
    //Antes que nada, debemos verificar si ya fue guardado en la base de datos
    //Esta situacion pasaria cuando el usuario ya haya tocado el boton de imprimir antes
    //Y por alguna razon, necesita volver a imprimir (pero los datos ya fueron guardados)

    if (this.state.guardado) {
      return;
    }

    //Luego, lo primero que hacemos es, verificamos si la persona tiene id, si es asi
    // es porque vino desde el servidor, porque ya existia.
    //Entonces, no debemos crearlo.

    if (this.state.persona._id) {
      //Si ya existia la persona, creamos solo la acreditacion.
      if (ventaSinStock) {
        //Esto significa que debemos generar la venta de la nueva forma.
        this.crearAcreditacionConVenta(this.state.persona._id);
      } else {
        this.crearVenta(this.state.persona._id);
      }
    }
  }

  // eslint-disable-next-line no-unused-vars
  crearAcreditacionConVenta = id => {
    let acreditacion;
    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles, extras, datosMP } = this.state;
    let detallesFiltrados = [];

    detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    let { email, enviarPorEmail, descargarRecibo } = extras;
    let venta;
    if (existeVenta && detalles.length > 0) {
      venta = {
        idVendedor: this.props.data.getUsuario._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        detalle: detallesFiltrados,
        datosPosnet:
          datosPosnet &&
          (datosPosnet.codigoOperacion || datosPosnet.numeroTicket)
            ? {
                codigoOperacion: datosPosnet.codigoOperacion,
                numeroTicket: datosPosnet.numeroTicket,
                cuenta: 'Tasas',
              }
            : null,
        datosMP: datosMP
          ? { numeroComprobante: datosMP.numeroComprobante }
          : null,
        datosRecibo: {
          email,
          enviarPorEmail,
          descargarRecibo,
        },
      };
    }
    //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..

    acreditacion = {
      fecha_creacion: new Date(),
      idAcreditado: this.state.persona._id,
      idOrganismo: this.props.data.getUsuario.organismo._id,
      idCreador: this.props.data.getUsuario._id,
    };

    this.props
      .crearAcreditacion({
        variables: { acreditacion: acreditacion, venta: venta },
      })
      .then(respuesta => {
        notification.success({
          message: 'Venta registrada',
          description: 'La venta se registro de forma exitosa',
        });

        notification.success({
          message: 'Nueva Acreditacion ',
          description: 'Se ha registrado con exito la acreditacion',
        });

        if (
          descargarRecibo &&
          respuesta.data.crearAcreditacion &&
          respuesta.data.crearAcreditacion.venta &&
          respuesta.data.crearAcreditacion.venta.recibo64
        ) {
          verPdf(
            respuesta.data.crearAcreditacion.venta.recibo64,
            `Recibo_Num_${respuesta.data.crearAcreditacion.venta.id}`
          );
        }

        this.setState(
          {
            ...this.state,
            acreditacion: {
              ...this.state.acreditacion,
              ...respuesta.data.crearAcreditacion,
            },
            guardado: true,
            loading: false,
          },
          () => {
            this.siguientePaso();
          }
        );
      })
      .catch(error => {
        console.log('Excepcion!!');
        console.log(error);
        this.setState({
          loading: false,
        });

        errorService(error, {
          acreditacion: acreditacion,
        });

        Modal.error({
          title: 'Error en la creacion de la acreditacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  // eslint-disable-next-line no-unused-vars
  crearVenta = idPersona => {
    let yo = this;

    let acreditacion;
    let modeloDetalleVenta = {
      idTipo_Sello: null,
      cantidad: null,
    };

    let { existeVenta, datosPosnet, detalles } = this.state;
    let detallesFiltrados = [];

    detallesFiltrados = _.map(detalles, detalle => {
      let result = _.pick(detalle, _.keys(modeloDetalleVenta));

      return result;
    });
    // delete datosPosnet.__typename;

    if (existeVenta && detalles.length > 0) {
      confirm({
        title: 'Está seguro de que desea crear la acreditacion CON VENTA?',
        content: 'No podrá hacer cambios sobre esta acreditacion',
        onOk: () => {
          this.setState({
            loading: true,
          });
          this.props
            .insertDetalleVenta({
              variables: { detalleVenta: { detalle: detallesFiltrados } },
            })
            .then(res => {
              //El detalle de venta se inserto correctamente. Ahora debemos crear la venta..
              let detalles = res.data.insertDetalleVenta.detalle;

              let importe = _.sum(
                _.map(detalles, detalle => {
                  //Esta funcion se encarga de multiplicar la cantidad de cada de talle por el valor de cada tipo_sello
                  return detalle.cantidad * detalle.tipo_sello.valor;
                })
              );

              // console.log('LALA: ', datosPosnet);
              // delete datosPosnet.__typename;
              let venta = {
                importe: importe,
                fecha: moment().toDate(),
                idVendedor: this.props.data.getUsuario._id,
                idOrganismo: this.props.data.getUsuario.organismo._id,
                idDetalle_Venta: res.data.insertDetalleVenta._id,
                datosPosnet:
                  (datosPosnet && (datosPosnet.codigoOperacion || datosPosnet.numeroTicket))
                    ? {
                        codigoOperacion: datosPosnet.codigoOperacion,
                        numeroTicket: datosPosnet.numeroTicket,
                        cuenta: 'Tasas',
                      }
                    : null,
              };

              this.props
                .insertVenta({
                  variables: { venta: venta },
                })
                .then(res => {
                  acreditacion = {
                    fecha_creacion: new Date(),
                    idAcreditado: this.state.persona._id,
                    idOrganismo: this.props.data.getUsuario.organismo._id,
                    idCreador: this.props.data.getUsuario._id,
                    idVenta: res.data.insertVenta._id,
                  };

                  this.props
                    .createAcreditacion({
                      variables: { acreditacion: acreditacion },
                    })
                    .then(respuesta => {
                      notification.success({
                        message: 'Venta registrada',
                        description: 'La venta se registro de forma exitosa',
                      });

                      notification.success({
                        message: 'Nueva Acreditacion ',
                        description:
                          'Se ha registrado con exito la acreditacion',
                      });

                      this.setState(
                        {
                          ...this.state,
                          acreditacion: {
                            ...this.state.acreditacion,
                            ...respuesta.data.insertAcreditacion,
                          },
                          guardado: true,
                          loading: false,
                        },
                        () => {
                          this.siguientePaso();
                        }
                      );
                    })
                    .catch(error => {
                      console.log('Excepcion!!');
                      console.log(error);
                      this.setState({
                        loading: false,
                      });

                      errorService(error, {
                        acreditacion: acreditacion,
                      });

                      Modal.error({
                        title: 'Error en la creacion de la acreditacion',
                        content:
                          'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
                      });
                    });
                  return res;
                })
                .catch(err => {
                  console.log('Se ha producido un error');
                  console.log(err);
                  errorService(err, {
                    venta: venta,
                  });
                  this.setState({
                    loading: false,
                  });
                  notification.error({
                    message: 'Error al registrar la venta',
                    description:
                      'Se ha producido un error al registrar la venta',
                  });

                  return err;
                });
            })
            .catch(err => {
              console.log(
                'Ocurrio un error a la hora de registrar el detalle de la venta'
              );
              console.log(err);
              errorService(err, {
                detalleVenta: { detalle: detallesFiltrados },
              });
              this.setState({
                loading: false,
              });

              Modal.error({
                title:
                  'Error en la creacion de la venta, compruebe que exista stock por favor',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
          errorService(
            new Error(
              'CANCELO LA CREACION DEL TRAMITE ACREDITACION "CON VENTA" '
            ),
            {
              estado: yo.state,
              existeVenta: existeVenta,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    } else {
      //caso donde solo debo crear la certificacion:

      confirm({
        title: 'Está seguro de que desea crear la acreditacion SIN VENTA?',
        content: 'No podrá hacer cambios sobre esta acreditacion',
        onOk: () => {
          this.setState({
            loading: true,
          });
          acreditacion = {
            fecha_creacion: new Date(),
            idAcreditado: this.state.persona._id,
            idOrganismo: this.props.data.getUsuario.organismo._id,
            idCreador: this.props.data.getUsuario._id,
          };

          this.props
            .createAcreditacion({
              variables: { acreditacion: acreditacion },
            })
            .then(respuesta => {
              notification.success({
                message: 'Nueva Acreditacion',
                description: 'Se ha registrado con exito la acreditacion',
              });

              this.setState(
                {
                  ...this.state,
                  acreditacion: {
                    ...this.state.acreditacion,
                    ...respuesta.data.insertAcreditacion,
                  },
                  guardado: true,
                  loading: false,
                },
                () => {
                  this.siguientePaso();
                }
              );
            })
            .catch(error => {
              console.log('Excepcion!!');
              console.log(error);
              this.setState({
                loading: false,
              });

              Modal.error({
                title: 'Error en la creacion de la acreditacion',
                content:
                  'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
              });
            });
        },
        onCancel() {
          console.log('Cancel');
          errorService(
            new Error(
              'CANCELO LA CREACION DEL TRAMITE ACREDITACION "SIN VENTA" '
            ),
            {
              respuestaServer: yo.state,
              existeVenta: existeVenta,
            }
          );
          yo.setState({
            loading: false,
          });
        },
      });
    }
  };

  ModeloNotaElegido = idNota => {
    // console.log("La nota tiene el id de ....", idNota.modelo);
    // console.log("La nota tiene el id de ....", this.state.nota.idModeloNota);

    this.setState(
      {
        ...this.state,
        nota: {
          ...this.state.nota,
          idModeloNota: idNota.modelo,
        },
        loading: true,
      },
      () => {
        // console.log("Entre!");

        this.props.client
          .mutate({
            mutation: obtenerNumeroTalonario,
            variables: {
              idModeloNota: this.state.nota.idModeloNota,
            },
          })
          .then(respuesta => {
            // console.log("Recibi de respuesta....");
            // console.log(respuesta);

            if (respuesta.data.obtenerNumeroTalonario == -1) {
              notification.warning({
                message: 'Talonario no configurado',
                description:
                  'El modelo de nota no tiene configurado el talonario a usar',
              });
            }

            this.setState({
              ...this.state,
              numero: respuesta.data.obtenerNumeroTalonario
                ? respuesta.data.obtenerNumeroTalonario
                : 0,
              loading: false,
            });

            // console.log("ESTADO: ");
            // console.log(this.state);
            this.siguientePaso();
          })
          .catch(err => {
            console.log('ERROR a la hora de obtener el numero del  talonario');
            console.log(err);
            this.setState({
              loading: false,
            });
          });
      }
    );
  };

  onCancel() {
    //El cancelar reinicia todo el estado de la aplicacion para volver a empezar desde 0
    this.setState({
      nota: {
        idModeloNota: '',
        titulo: '',
        descripcion: '',
        htmlModelo: '',
      },
      persona: {},
      numero: '',
      guardado: false,
      confirmado: false,
      existeVenta: false,
      step: 0,
    });
    this.props.history.push('/');
  }

  siguientePaso() {
    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  }

  anteriorPaso() {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  }

  render() {
    const { Step } = Steps;
    const { data } = this.props;
    const usuario = data ? data.getUsuario : {};
    let { step } = this.state;

    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Acreditacion</Breadcrumb.Item>
          <Breadcrumb.Item>Nueva</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nueva Acreditacion
          </h2>
          <br />
          <Steps size="small" className="stepsFormularios" current={step}>
            <Step title="Buscar Persona" />
            <Step title="Acreditacion" />
            <Step title="Modelo Nota" />
            <Step title="Generacion de Nota" />
            <Step title="Editar e Imprimir" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarPersona} />
            )}

            {step === 1 && (
              <FormAcreditacion
                organismo={usuario.organismo}
                onFinalizar={(datos, ventaSinStock) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDatosAcreditacion(datos, ventaSinStock)
                  )
                }
                onSubmit={(datos, ventaSinStock) =>
                  this.setState({ loading: true }, () =>
                    this.guardarDatosAcreditacion(datos, ventaSinStock)
                  )
                }
                config={{ creacion: true }}
                usuario={usuario}
              />
            )}

            {step === 2 && (
              <SelectorModelo
                handleChange={this.notaSeleccionada}
                onSubmit={this.ModeloNotaElegido}
              />
            )}
            {step === 3 && (
              <Generador
                id={this.state.nota.idModeloNota}
                // datos={this.state.persona}
                datos={this.obtenerDatosGeneracion()}
                mostrarEditor={this.finProcesoGeneracion}
              />
            )}
            {step === 4 && (
              <CKEditor
                modelo_nota={this.state.nota}
                onImprimir={this.onImprimir}
                onGuardar={this.confirmarAcreditacion}
                onCancel={this.onCancel}
                accion="visualizar"
              />
            )}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearAcreditacion);
